module.exports = __webpack_public_path__ + "static/media/credit-card-payment.85b4a3d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/credit-card-payment.jpg
// module id = 554
// module chunks = 0